<template>
  <div>
    <NavigationBar
      :showBackBtn="!isPropMode"
      titel="Details"
      :actions="actions"
    >
    </NavigationBar>
    <section>
      <template>
        <v-container fluid>
          <!-- Loading State -->
          <template v-if="helpers.dataIsLoading">
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-skeleton-loader
                  elevation="2"
                  type="card-heading, list-item-three-line, divider, list-item-two-line, list-item-two-line"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col cols="6">
                    <v-skeleton-loader
                      elevation="2"
                      type="card-heading, text"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col cols="6">
                    <v-skeleton-loader
                      elevation="2"
                      type="card-heading, text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader
                  elevation="2"
                  type="card-heading, divider, table-heading, table-row-divider, table-row-divider, table-row-divider, table-row-divider, table-row"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader
                  elevation="2"
                  type="card-heading, divider, list-item-avatar-two-line, list-item-avatar-two-line"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>

          <!-- Loaded Content -->
          <template v-else>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <report-details-card
                  :loading="helpers.dataIsLoading"
                  :report="report"
                ></report-details-card>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-row class="match-height">
                  <v-col cols="6">
                    <statistics-single-card
                      title="Dauer"
                      color="blue-grey"
                      icon="mdi-timer-sand-complete"
                      :value="getReportDurationText()"
                    ></statistics-single-card>
                  </v-col>
                  <v-col cols="6">
                    <statistics-single-card
                      title="Teilnehmer"
                      color="blue-grey"
                      icon="mdi-counter"
                      :value="reportParticipantsCount"
                    ></statistics-single-card>
                  </v-col>

                  <!-- <v-col cols="12" md="6" sm="6">
                  <statistics-single-card
                    :title="
                      report.status === 'finished'
                        ? 'Abgeschlossen am'
                        : 'Fällig bis'
                    "
                    :color="report.status === 'finished' ? 'green' : 'red'"
                    :icon="
                      report.status === 'finished'
                        ? 'mdi-archive-lock-outline'
                        : 'mdi-calendar-alert'
                    "
                    value="XX.XX.2024"
                  ></statistics-single-card>
                </v-col> -->
                  <!-- <v-col cols="12" md="6" sm="6">
                  <statistics-single-card
                    :title="
                      report.status === 'finished'
                        ? 'Abgeschlossen von'
                        : 'Berichtsverantwortlich'
                    "
                    :color="report.status === 'finished' ? 'green' : 'red'"
                    :icon="
                      report.status === 'finished'
                        ? 'mdi-account-lock'
                        : 'mdi-account-alert'
                    "
                    :value="report.assignedTo.displayName"
                  ></statistics-single-card>
                </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-title class="subtitle-1 font-weight-medium">
                    Anwesenheiten
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                    depressed
                    color="primary"
                    small
                    @click="toggleAddAttendanceEntry()"
                    ><v-icon left>mdi-plus</v-icon>Eintrag nachträglich
                    hinzufügen</v-btn
                  > -->
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text v-if="dutyAttendances.length > 0">
                    <payroll-type-time-summary
                      :attendances="dutyAttendances"
                      :payroll-types="usedPayrollTypes"
                    />
                  </v-card-text>
                  <v-divider v-if="dutyAttendances.length > 0"></v-divider>
                  <v-data-table
                    dense
                    :items="dutyAttendances"
                    :headers="helpers.attendanceTable.headers"
                    fixed-header
                    height="660px"
                    group-by="attendanceStatus"
                    sort-by="user.lastName"
                    item-key="meta.id"
                    disable-pagination
                    hide-default-footer
                    :mobile-breakpoint="0"
                    no-data-text="Keine Anwesenheiten erfasst"
                  >
                    <template
                      v-slot:[`group.header`]="{ items, isOpen, toggle }"
                    >
                      <th :colspan="helpers.attendanceTable.headers.length">
                        <v-icon @click="toggle" class="mr-2"
                          >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                        </v-icon>

                        {{ getAttendanceStatusText(items[0].attendanceStatus) }}
                      </th>
                      <th>
                        <v-icon small>mdi-sigma</v-icon>{{ items.length }}
                      </th>
                    </template>
                    <template v-slot:[`item.meta.id`]="{ item }">
                      <small>
                        <code>{{ item.meta.id }}</code>
                      </small>
                    </template>
                    <template v-slot:[`item.user.lastName`]="{ item }">
                      {{ item.user.lastName }}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-if="item.connectedTimeSheet?.id"
                            icon
                            x-small
                            text
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :to="{
                              name: 'accounting-time-sheets-details',
                              params: {
                                organizationId: organizationId,
                                itemId: item.connectedTimeSheet?.id,
                              },
                            }"
                            ><v-icon x-small>mdi-open-in-app</v-icon></v-btn
                          >
                        </template>
                        <span>Stundenmeldung öffnen</span>
                      </v-tooltip>
                    </template>
                    <template
                      v-slot:[`item.duration.start.timestamp`]="{ item }"
                    >
                      {{
                        item.attendanceStatus == "1"
                          ? timestampConverter(item.duration.start.timestamp)
                          : "–"
                      }}
                    </template>
                    <template v-slot:[`item.duration.end.timestamp`]="{ item }"
                      >{{
                        item.attendanceStatus == "1"
                          ? timestampConverter(item.duration.end.timestamp)
                          : "–"
                      }}
                    </template>
                    <template
                      v-slot:[`item.assignedPosition.unit.title`]="{ item }"
                    >
                      {{ item.assignedPosition.unit.title }} –
                      {{ item.assignedPosition.position.shortTitle }}
                    </template>
                    <template v-slot:[`item.note`]="{ item }">
                      <v-chip v-if="item.isWaiver" small outlined
                        ><v-icon left small>mdi-account-alert-outline</v-icon
                        >Verzicht</v-chip
                      >{{ item.note }}
                    </template>
                  </v-data-table>
                </v-card></v-col
              >
            </v-row>
            <v-row>
              <v-col cols="12">
                <LogsCommentsTimeline
                  :timeline-entries="logsAndComments"
                  :show-comment-form="true"
                  comment-form-label="Kommentar hinzufügen"
                  comment-form-button-text="Hinzufügen"
                  :action-text-map="actionTextMap"
                  :color-map="colorMap"
                  :icon-map="iconMap"
                  :timestamp-converter="timestampConverter"
                  @add-comment="handleAddComment"
                >
                </LogsCommentsTimeline>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </template>
    </section>
    <custom-dialog
      v-if="helpers.approveReportDialog.model"
      @close="toggleApproveReportDialog()"
      title="Dienstbericht genehmigen"
      text="Änderungen müssen vor der Genehmigung durchgeführt werden. Die Genehmigung wird dann entsprechend gekennzeichnet (Genehmigt mit Änderungen)."
      width="s"
      :errorMessage="helpers.approveReportDialog.errorMessage"
      :loading="helpers.approveReportDialog.isLoading"
      :btnAction="approveReport"
      btnText="Genehmigen"
      fullscreenOnMobile
    >
      <template v-if="comments.length" v-slot:top>
        <v-alert dense text type="error"
          >Kommentare zu diesem Dienstbericht beachten</v-alert
        >
      </template>
      <template v-slot:content>
        <v-form
          v-model="helpers.approveReportDialog.formIsValid"
          ref="approveDialogForm"
          @submit.prevent="approveReport()"
          ><v-textarea
            v-model="helpers.approveReportDialog.reasonValue"
            outlined
            label="Begründung/Vermerk"
            auto-grow
            persistent-hint
            hint="Optional"
            class="mt-2 pb-0 m0-0"
          ></v-textarea>
          <v-checkbox
            v-model="
              helpers.approveReportDialog.autoApproveCorrespondingTimeSheets
            "
            label="Stundenmeldungen für Dienstbericht automatisch genehmigen"
          ></v-checkbox>
        </v-form>
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.moveBackToReviewDialog.model"
      @close="toggleMoveBackToReviewDialog()"
      title="Dienstbericht zur Überprüfung übergeben"
      width="s"
      :errorMessage="helpers.moveBackToReviewDialog.errorMessage"
      :loading="helpers.moveBackToReviewDialog.isLoading"
      :btnAction="moveBackToReview"
      fullscreenOnMobile
    >
      <template v-if="comments.length" v-slot:top>
        <v-alert dense text type="error"
          >Kommentare zu diesem Dienstbericht beachten</v-alert
        >
      </template>
      <template v-slot:content>
        <v-form
          v-model="helpers.moveBackToReviewDialog.formIsValid"
          ref="allowMoveBackToReviewForm"
          @submit.prevent="moveBackToReview()"
          ><v-textarea
            v-model="helpers.moveBackToReviewDialog.reasonValue"
            outlined
            label="Begründung/Vermerk"
            auto-grow
            persistent-hint
            hint="Optional"
            class="mt-2 pb-0 m0-0"
          ></v-textarea>
        </v-form>
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.rejectReportDialog.model"
      @close="toggleRejectReportDialog()"
      title="Dienstbericht ablehnen"
      width="s"
      :errorMessage="helpers.rejectReportDialog.errorMessage"
      :loading="helpers.rejectReportDialog.isLoading"
      :btnAction="rejectReport"
      :btnDisabled="!helpers.rejectReportDialog.formIsValid"
      btnText="Ablehnen"
      fullscreenOnMobile
    >
      <template v-if="comments.length" v-slot:top>
        <v-alert dense text type="error"
          >Kommentare zu diesem Dienstbericht beachten</v-alert
        >
      </template>
      <template v-slot:content>
        <v-form
          v-model="helpers.rejectReportDialog.formIsValid"
          ref="rejectDialogForm"
          @submit.prevent="rejectReport()"
          ><v-textarea
            v-model="helpers.rejectReportDialog.reasonValue"
            outlined
            label="Begründung/Vermerk"
            auto-grow
            required
            :rules="[rules.required]"
            hide-details="auto"
            class="mt-2 pb-0 m0-0"
          ></v-textarea>
        </v-form>
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.archiveReportDialog.model"
      @close="toggleArchiveReportDialog()"
      title="Dienstbericht archivieren"
      width="s"
      :errorMessage="helpers.archiveReportDialog.errorMessage"
      :loading="helpers.archiveReportDialog.isLoading"
      :btnAction="archiveReport"
      :btnDisabled="!helpers.archiveReportDialog.formIsValid"
      btnText="Archivieren"
      fullscreenOnMobile
    >
      <template v-if="comments.length" v-slot:top>
        <v-alert dense text type="error"
          >Kommentare zu diesem Dienstbericht beachten</v-alert
        >
      </template>
      <template v-slot:content>
        <v-form
          v-model="helpers.archiveReportDialog.formIsValid"
          ref="archiveDialogForm"
          @submit.prevent="archiveReport()"
          ><v-textarea
            v-model="helpers.archiveReportDialog.reasonValue"
            outlined
            label="Begründung/Vermerk"
            auto-grow
            required
            :rules="[rules.required]"
            hide-details="auto"
            class="mt-2 pb-0 m0-0"
          ></v-textarea>
        </v-form>
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.editReportDialog.model"
      @close="toggleEditReportDialog()"
      title="Dienstbericht zur Korrektur übernehmen"
      text="Änderungen müssen vor der Genehmigung durchgeführt werden. Der Dienstbericht wird dann entsprechend gekennzeichnet (Korrekturmodus). Nur eine Person kann korrekturverantwortlich sein."
      width="s"
      :errorMessage="helpers.editReportDialog.errorMessage"
      :loading="helpers.editReportDialog.isLoading"
      :btnAction="editReport"
      btnText="Korrektur übernehmen"
      fullscreenOnMobile
    >
      <template v-if="comments.length" v-slot:top>
        <v-alert dense text type="error"
          >Kommentare zu dieser Stundenmeldung beachten</v-alert
        >
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.addAttendanceEntry.model"
      @close="toggleAddAttendanceEntry()"
      title="Anwesenheitseintrag nachträglich hinzufügen"
      text="Lediglich zu Dokumentationszwecken können Anwesenheitseinträge nachträglich hinzugefügt werden. Es wird jedoch keine Stundenmeldung erzeugt."
      width="s"
      :errorMessage="helpers.addAttendanceEntry.errorMessage"
      :loading="helpers.addAttendanceEntry.isLoading"
      :btnAction="addAttendanceEntry"
      btnText="Hinzufügen"
      fullscreenOnMobile
    >
      <template v-slot:top>
        <v-alert dense text type="error"
          >Dieser Anwesenheitseintrag fließt nicht automatisch in die Abrechnung
          ein.</v-alert
        >
      </template>
      <template v-slot:content>
        <v-form
          v-model="helpers.approveReportDialog.formIsValid"
          ref="approveDialogForm"
          @submit.prevent="approveReport()"
        >
          Startzeitpunkt Endzeitpunkt Abrechnungsart Bemerkung
        </v-form>
      </template>
    </custom-dialog>
    <custom-dialog
      v-if="helpers.editTrainingDialog.model"
      @close="toggleEditTrainingDialog()"
      title="Ausbildungsdaten bearbeiten"
      text="Änderungen an den Ausbildungsdaten werden protokolliert und können auch nach der Genehmigung vorgenommen werden."
      width="m"
      :errorMessage="helpers.editTrainingDialog.errorMessage"
      :loading="helpers.editTrainingDialog.isLoading"
      :btnAction="updateTrainingData"
      btnText="Speichern"
      fullscreenOnMobile
    >
      <template v-slot:content>
        <v-form
          v-model="helpers.editTrainingDialog.formIsValid"
          ref="editTrainingForm"
          @submit.prevent="updateTrainingData()"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model.trim="helpers.editTrainingDialog.data.subject"
                label="Ausbildungsthema"
                hide-details="auto"
                clearable
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="helpers.editTrainingDialog.data.categories"
                :items="availableTrainingCategories"
                label="Ausbildungskategorien"
                hide-details="auto"
                clearable
                chips
                multiple
                outlined
                small-chips
                deletable-chips
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Neuen Eintrag eingeben und mit
                        <kbd>enter</kbd> bestätigen.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="helpers.editTrainingDialog.data.responsibleInstructors"
                :items="availableMemberships"
                item-text="displayName"
                return-object
                label="Verantwortliche Ausbilder"
                hide-details="auto"
                clearable
                deletable-chips
                small-chips
                multiple
                outlined
              >
              </v-select>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </custom-dialog>
    <v-snackbar
      v-model="helpers.snackbar.isVisible"
      class="pb-4"
      bottom
      app
      timeout="3000"
      :color="helpers.snackbar.color"
      ><v-icon class="mr-1">mdi-check-circle</v-icon>
      {{ helpers.snackbar.message }}
    </v-snackbar>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import { db, auth, FieldValue, Timestamp, functions } from "@/firebase";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import PayrollTypeTimeSummary from "@/components/duty-management/PayrollTypeTimeSummary.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import ReportDetailsCard from "@/components/duty-management/ReportDetailsCard.vue";
import StatisticsSingleCard from "@/components/statistics/StatisticsSingleCard.vue";
import LogsCommentsTimeline from "@/components/_systemwide/LogsCommentsTimeline.vue";
import {
  DUTY_MANAGEMENT_REPORTS_review,
  DUTY_MANAGEMENT_REPORTS_update,
} from "@/data/permission-types.js";
import { ADMIN } from "@/store/modules.js";
import { GET_USER_LIST } from "@/store/action-types.js";
export default {
  name: "duty-management-reports-details",
  components: {
    NavigationBar,
    PayrollTypeTimeSummary,
    ReportDetailsCard,
    SupportTools,
    StatisticsSingleCard,
    CustomDialog,
    LogsCommentsTimeline,
  },
  props: {
    // When provided, component uses this data instead of fetching from Firestore
    // Used in split-view mode where parent already has report data from Vuex
    reportProp: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
      helpers: {
        dataIsLoading: false,
        addAttendanceEntry: {
          model: false,
          errorMessage: "",
          isLoading: false,
          data: {},
        },
        archiveReportDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
          reasonValue: "",
        },
        approveReportDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
          reasonValue: "",
          autoApproveCorrespondingTimeSheets: true,
        },
        rejectReportDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
          reasonValue: "",
        },
        moveBackToReviewDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
          reasonValue: "",
        },
        editReportDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
        },
        editTrainingDialog: {
          model: false,
          errorMessage: "",
          isLoading: false,
          formIsValid: true,
          data: {
            subject: "",
            categories: [],
            responsibleInstructors: [],
          },
        },
        snackbar: {
          message: "",
          isVisible: false,
        },
        commentForm: {
          isLoading: false,
          value: "",
          errorMessage: "",
        },
        attendanceTable: {
          headers: [
            { text: "Vorname", value: "user.firstName" },
            { text: "Nachname", value: "user.lastName", divider: true },
            {
              text: "Startzeitpunkt",
              value: "duration.start.timestamp",
              divider: true,
            },
            {
              text: "Endzeitpunkt",
              value: "duration.end.timestamp",
              divider: true,
            },
            {
              text: "Abrechnungsart",
              value: "payrollType.title",
              divider: true,
            },
            {
              text: "Einsatzmittel/Position",
              value: "assignedPosition.unit.title",
              divider: true,
            },
            {
              text: "Bemerkung",
              value: "note",
              divider: true,
            },
          ],
          expandedRows: [],
        },
      },
      report: null,
      dutyAttendances: [],
      logs: [],
      comments: [],

      reportUnsubscribe: null,
      dutyAttendancesUnsubscribe: null,
      logsUnsubscribe: null,
      commentsUnsubscribe: null,
    };
  },
  beforeDestroy() {
    if (this.reportUnsubscribe) {
      this.reportUnsubscribe();
      this.reportUnsubscribe = null;
    }
    if (this.dutyAttendancesUnsubscribe) {
      this.dutyAttendancesUnsubscribe();
      this.dutyAttendancesUnsubscribe = null;
    }
    if (this.logsUnsubscribe) {
      this.logsUnsubscribe();
      this.logsUnsubscribe = null;
    }
    if (this.commentsUnsubscribe) {
      this.commentsUnsubscribe();
      this.commentsUnsubscribe = null;
    }
  },
  computed: {
    actions() {
      const reportStatus = this.report ? this.report.status : null;
      const actions = [
        {
          title: "Aktionen",
          icon: "mdi-dots-horizontal-circle",
          actionStyle: "textBtnMultiple",
          list: [
            {
              title: "Archivieren",
              permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
              // customPermission: isEventOrganizerWithPermission,
              icon: "mdi-archive-cancel",
              disabled: reportStatus !== "toBeReviewed", // should only be true, if timeSheetStatus === 'toBeReviewed'
              function: this.toggleArchiveReportDialog,
            },
            { divider: true },
            {
              title: "Ausbildungsdaten bearbeiten",
              permission: `${DUTY_MANAGEMENT_REPORTS_update}`,
              icon: "mdi-school",
              function: this.toggleEditTrainingDialog,
            },
            {
              title: "Qualifikationsmeldung generieren",
              permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
              // customPermission: isEventOrganizerWithPermission,
              icon: "mdi-certificate",
              disabled: true,
              // function: this.toggleRecalculateSalaryDialog,
            },
            {
              title: "Dienstbericht exportieren ",
              permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
              icon: "mdi-file-export",
              disabled: true,
              // function: this.createFromCSV,
            },
          ],
        },
        { divider: true },
        { actionStyle: "clipboardBtn" },
      ];
      const approveAction = {
        title: "Genehmigen",
        icon: "mdi-check-circle-outline",
        permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
        color: "success",
        actionStyle: "textBtnSubmit",
        function: this.toggleApproveReportDialog,
      };
      const rejectAction = {
        title: "Ablehnen",
        permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
        icon: "mdi-close-circle-outline",
        actionStyle: "textBtnSubmit",
        color: "error",
        function: this.toggleRejectReportDialog,
      };
      const editAction = {
        title: "Bearbeiten",
        permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
        icon: "mdi-pencil",
        actionStyle: "textBtn",
        function: this.toggleEditReportDialog,
      };
      const allowReviewAction = {
        title: "Erneute Prüfung",
        permission: `${DUTY_MANAGEMENT_REPORTS_review}`,
        icon: "mdi-check-all",
        actionStyle: "textBtn",
        color: "purple",
        function: this.toggleMoveBackToReviewDialog,
      };
      if (reportStatus === "inProgress" || reportStatus === "inCorrection") {
        actions.unshift(editAction);
      } else if (reportStatus === "toBeReviewed") {
        actions.unshift(editAction);
        actions.unshift(rejectAction);
        actions.unshift(approveAction);
      } else if (
        reportStatus === "approved" ||
        reportStatus === "rejected" ||
        reportStatus === "archived"
      ) {
        actions.unshift(allowReviewAction);
      }
      return actions;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        { title: "report", data: this.report },
        { title: "dutyAttendances", data: this.dutyAttendances },
        { title: "logsAndComments", data: this.logsAndComments },
      ];
    },
    logsAndComments() {
      return this.logs
        .concat(this.comments)
        .sort((a, b) => b.timestamp - a.timestamp);
    },
    reportParticipantsCount() {
      return this.dutyAttendances.filter(
        (attendance) => attendance.attendanceStatus === "1",
      ).length;
    },
    usedPayrollTypes() {
      return this.dutyAttendances
        .map((attendance) => attendance.payrollType)
        .filter((type, index, self) => self.indexOf(type) === index);
    },
    actionTextMap() {
      return {
        created: "hat den Dienstbericht erstellt.",
        approved: "hat den Dienstbericht genehmigt.",
        toBeReviewed: "hat den Dienstbericht zur Prüfung übergeben.",
        rejected: "hat den Dienstbericht abgelehnt.",
        comment: "hat einen Kommentar hinzugefügt:",
        reassigned:
          "hat die Berichtsverantwortung für den Dienstbericht übernommen.",
        reassignedTakeOver:
          "hat die Berichtsverantwortung für den Dienstbericht übernommen.",
        reassignedCorrection: "hat den Dienstbericht zur Korrektur übernommen.",
        completed: "hat den Dienstbericht festgeschrieben.",
        paid: "hat die Auszahlung von Stundenmeldungen aus diesem Dienstbericht erfasst.",
        archived: "hat den Dienstbericht archiviert.",
        updatedTrainingData: "hat die Ausbildungsdaten aktualisiert.",
        staleReportReminder:
          "hat eine automatische Erinnerung versendet, weil der Dienstbericht noch nicht innerhalb der vorgegebenen Frist abgeschlossen wurde.",
      };
    },
    colorMap() {
      return {
        created: "primary",
        approved: "green",
        completed: "green",
        paid: "green",
        toBeReviewed: "purple",
        rejected: "red",
        reassigned: "primary",
        reassignedTakeOver: "primary",
        reassignedCorrection: "primary",
        comment: "grey",
        archived: "grey blue",
        updatedTrainingData: "orange",
        staleReportReminder: "warning",
      };
    },
    iconMap() {
      return {
        created: "mdi-plus",
        approved: "mdi-check",
        toBeReviewed: "mdi-check-all",
        rejected: "mdi-close",
        reassigned: "mdi-account-switch",
        reassignedTakeOver: "mdi-account-switch",
        reassignedCorrection: "mdi-account-switch",
        comment: "mdi-comment-text",
        completed: "mdi-archive-check",
        paid: "mdi-cash-check",
        archived: "mdi-archive-cancel",
        updatedTrainingData: "mdi-school-outline",
        staleReportReminder: "mdi-bell-alert",
      };
    },
    // Returns true when component receives data via prop (split-view mode)
    isPropMode() {
      return this.reportProp !== null;
    },
    // Get organization ID from route or report data
    organizationId() {
      return this.$route.params.organizationId || this.report?.organizationId;
    },
    // Get report ID from route params or from prop data
    reportId() {
      if (this.isPropMode && this.reportProp) {
        return this.reportProp.meta?.id;
      }
      return this.$route.params.itemId;
    },
    availableTrainingCategories() {
      return (
        this.$store.state.organization.activeOrganization?.config
          ?.dutyManagement?.trainingCategories || []
      );
    },
    availableMemberships() {
      return this.$store.state.admin.membershipsPublic.map((membership) => ({
        uid: membership.user.uid,
        membershipId: membership.user.membershipId,
        displayName: membership.user.displayName,
      }));
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    // Only watch route params, not query params (filters)
    // This prevents re-fetching when only URL query params change
    "$route.params.organizationId": "initialize",
    "$route.params.itemId": "initialize",
    // Watch for reportProp changes to update local state and refetch subcollections
    reportProp: {
      handler(newReport) {
        if (this.isPropMode && newReport) {
          this.report = newReport;
          // Refetch subcollections when report changes in prop mode
          this.fetchSubcollections();
        }
      },
      deep: true,
    },
  },
  methods: {
    async initialize() {
      // Set loading state
      this.helpers.dataIsLoading = true;

      // Unsubscribe previous listeners if exist
      if (this.reportUnsubscribe) {
        this.reportUnsubscribe();
        this.reportUnsubscribe = null;
      }
      if (this.dutyAttendancesUnsubscribe) {
        this.dutyAttendancesUnsubscribe();
        this.dutyAttendancesUnsubscribe = null;
      }
      if (this.logsUnsubscribe) {
        this.logsUnsubscribe();
        this.logsUnsubscribe = null;
      }
      if (this.commentsUnsubscribe) {
        this.commentsUnsubscribe();
        this.commentsUnsubscribe = null;
      }

      try {
        if (this.isPropMode) {
          // Prop mode: Use prop data for report, only fetch subcollections
          this.report = this.reportProp;
          await this.fetchSubcollections();
        } else {
          // Route mode: Fetch everything from Firestore
          await Promise.all([
            this.getReport(),
            this.getDutyAttendances(),
            this.getLogs(),
            this.getComments(),
          ]);
        }
      } catch (error) {
        this.$emit("error", error);
        // Optionally, show a snackbar or alert here
      }

      this.helpers.dataIsLoading = false;

      if (this.checkIfSupport) {
        this.helpers.attendanceTable.headers.push({
          text: "ID",
          value: "meta.id",
          divider: true,
        });
      }
    },
    // Fetch only subcollections - used in prop mode
    async fetchSubcollections() {
      if (!this.reportId || !this.organizationId) return;
      await Promise.all([
        this.getDutyAttendances(),
        this.getLogs(),
        this.getComments(),
      ]);
    },
    getReport() {
      // Always clear previous listener before setting a new one
      if (this.reportUnsubscribe) {
        this.reportUnsubscribe();
        this.reportUnsubscribe = null;
      }

      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.organizationId)
          .collection("dutyReports")
          .doc(this.reportId);

        this.reportUnsubscribe = ref.onSnapshot((doc) => {
          if (doc.exists) {
            this.report = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
          resolve();
        });
      });
    },
    getDutyAttendances() {
      // Clear previous listener if exists
      if (this.dutyAttendancesUnsubscribe) {
        this.dutyAttendancesUnsubscribe();
        this.dutyAttendancesUnsubscribe = null;
      }

      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.organizationId)
          .collection("dutyReports")
          .doc(this.reportId)
          .collection("dutyAttendances");
        console.log("Fetching dutyAttendances");
        this.dutyAttendancesUnsubscribe = ref.onSnapshot(
          (querySnapshot) => {
            this.dutyAttendances = [];
            querySnapshot.forEach((doc) => {
              this.dutyAttendances.push(doc.data());
            });
            resolve();
          },
          (error) => {
            console.log("Error getting dutyAttendances:", error);
            resolve();
          },
        );
      });
    },
    getLogs() {
      // Clear previous listener if exists
      if (this.logsUnsubscribe) {
        this.logsUnsubscribe();
        this.logsUnsubscribe = null;
      }

      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.organizationId)
          .collection("dutyReports")
          .doc(this.reportId)
          .collection("logs");

        this.logsUnsubscribe = ref.onSnapshot(
          (querySnapshot) => {
            const logs = [];
            querySnapshot.forEach((doc) => {
              logs.push(doc.data());
            });
            this.logs = logs;
            resolve();
          },
          (error) => {
            console.log("Error getting logs:", error);
            resolve();
          },
        );
      });
    },
    getComments() {
      // Clear previous listener if exists
      if (this.commentsUnsubscribe) {
        this.commentsUnsubscribe();
        this.commentsUnsubscribe = null;
      }

      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.organizationId)
          .collection("dutyReports")
          .doc(this.reportId)
          .collection("comments");

        this.commentsUnsubscribe = ref.onSnapshot(
          (querySnapshot) => {
            const comments = [];
            querySnapshot.forEach((doc) => {
              comments.push(doc.data());
            });
            this.comments = comments;
            resolve();
          },
          (error) => {
            console.log("Error getting comments:", error);
            resolve();
          },
        );
      });
    },
    handleAddComment(commentData) {
      if (commentData.text.trim() === "") {
        commentData.formData.errorMessage =
          "Fehler: Es sind nicht alle Pflichtangaben ausgefüllt.";
        return;
      }

      commentData.formData.isLoading = true;
      commentData.formData.errorMessage = "";

      const commentRef = db
        .collection("organizations")
        .doc(this.organizationId)
        .collection("dutyReports")
        .doc(this.reportId)
        .collection("comments")
        .doc();

      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      return commentRef
        .set({
          user: {
            displayName: auth.currentUser.displayName,
            uid: auth.currentUser.uid,
          },
          type: "comment",
          text: commentData.text,
          mentions: [],
          timestamp: FieldValue.serverTimestamp(),
          id: commentRef.id,
        })
        .then(async () => {
          await delay(800);
          commentData.clearForm();
          commentData.formData.isLoading = false;
        })
        .catch(async (error) => {
          console.error("Error adding document: ", error);
          await delay(800);
          commentData.formData.errorMessage = error.message;
          commentData.formData.isLoading = false;
        });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    getAttendanceStatusText(statusId) {
      switch (statusId) {
        case "1":
          return "Anwesend";
        case "2":
          return "Entschuldigt";
        case "3":
          return "Unentschuldigt";
        default:
          return "Fehler";
      }
    },
    getReportDurationText() {
      if (!this.report || !this.report.duration?.start?.timestamp) {
        return "–";
      }
      // Retrieve the start and end timestamps
      const startTimestamp = this.report.duration.start.timestamp;
      let endTimestamp = this.report.duration.end.timestamp;

      // If endTimestamp is null, use the current timestamp
      if (!endTimestamp) {
        endTimestamp = Timestamp.now();
      }

      // Calculate the duration in milliseconds
      const durationMs = endTimestamp - startTimestamp;

      // Convert the duration to hours and minutes
      const durationMinutes = Math.floor(durationMs / 60);
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;

      // Return the duration in a readable format
      return `${hours}h ${minutes}min`;
    },
    toggleEditReportDialog() {
      if (
        this.report.status === "inProgress" ||
        (this.report.status === "inCorrection" &&
          this.report.correctedBy.uid === auth.currentUser.uid)
      ) {
        const route = {
          name: "duty-management-reports-live",
          params: {
            organizationId: this.organizationId,
            itemId: this.reportId,
          },
        };
        // In prop mode (split-view), open in new tab to preserve split context
        if (this.isPropMode) {
          window.open(this.$router.resolve(route).href, "_blank");
        } else {
          this.$router.push(route);
        }
      } else {
        this.helpers.editReportDialog.model =
          !this.helpers.editReportDialog.model;
        this.helpers.editReportDialog.errorMessage = "";
      }
    },
    toggleArchiveReportDialog() {
      this.helpers.archiveReportDialog.model =
        !this.helpers.archiveReportDialog.model;
      this.helpers.archiveReportDialog.errorMessage = "";
      this.helpers.archiveReportDialog.reasonValue = "";
    },
    toggleApproveReportDialog() {
      this.helpers.approveReportDialog.model =
        !this.helpers.approveReportDialog.model;
      this.helpers.approveReportDialog.errorMessage = "";
      this.helpers.approveReportDialog.reasonValue = "";
    },
    toggleRejectReportDialog() {
      this.helpers.rejectReportDialog.model =
        !this.helpers.rejectReportDialog.model;
      this.helpers.rejectReportDialog.errorMessage = "";
      this.helpers.rejectReportDialog.reasonValue = "";
    },
    toggleMoveBackToReviewDialog() {
      this.helpers.moveBackToReviewDialog.model =
        !this.helpers.moveBackToReviewDialog.model;
      this.helpers.moveBackToReviewDialog.errorMessage = "";
      this.helpers.moveBackToReviewDialog.reasonValue = "";
    },
    toggleEditTrainingDialog() {
      if (!this.helpers.editTrainingDialog.model && this.report) {
        // Opening dialog - fetch memberships only if not already loaded
        if (this.$store.state.admin.membershipsPublic.length === 0) {
          this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
            organizationId: this.$route.params.organizationId,
            queryIsFiltered: true,
            query: {
              type: "active",
            },
          });
        }
        // Populate with current data
        this.helpers.editTrainingDialog.data = {
          subject: this.report.training?.subject || "",
          categories: [...(this.report.training?.categories || [])],
          responsibleInstructors: [
            ...(this.report.training?.responsibleInstructors || []),
          ],
        };
      }
      this.helpers.editTrainingDialog.model =
        !this.helpers.editTrainingDialog.model;
      this.helpers.editTrainingDialog.errorMessage = "";
    },
    updateTrainingData() {
      this.helpers.editTrainingDialog.isLoading = true;
      const callFunction = functions.httpsCallable(
        "dutyManagement-updateReportTrainingData",
      );
      return callFunction({
        organizationId: this.$route.params.organizationId,
        dutyReportId: this.report.meta.id,
        training: this.helpers.editTrainingDialog.data,
      })
        .then(() => {
          this.helpers.editTrainingDialog.isLoading = false;
          this.toggleEditTrainingDialog();
          this.helpers.snackbar.message = "Ausbildungsdaten aktualisiert.";
          this.helpers.snackbar.isVisible = true;
        })
        .catch((error) => {
          this.helpers.editTrainingDialog.isLoading = false;
          this.helpers.editTrainingDialog.errorMessage = error.message;
          console.error("Error updating training data: ", error);
        });
    },
    editReport() {
      this.helpers.editReportDialog.isLoading = true;
      const callFunction = functions.httpsCallable(
        "dutyManagement-reassignReport",
      );
      return callFunction({
        organizationId: this.organizationId,
        dutyReportId: this.report.meta.id,
        reassignTo: {
          uid: auth.currentUser.uid,
        },
        reassignMode: "correction",
      })
        .then(() => {
          const route = {
            name: "duty-management-reports-live",
            params: {
              organizationId: this.organizationId,
              itemId: this.reportId,
            },
          };
          // In prop mode (split-view), open in new tab to preserve split context
          if (this.isPropMode) {
            window.open(this.$router.resolve(route).href, "_blank");
            this.helpers.editReportDialog.isLoading = false;
            this.helpers.editReportDialog.model = false;
          } else {
            this.$router.push(route);
          }
        })
        .catch((error) => {
          this.helpers.editReportDialog.isLoading = false;
          this.helpers.editReportDialog.errorMessage = error.message;
          console.error("Error starting correction mode report: ", error);
        });
    },
    approveReport() {
      this.helpers.approveReportDialog.isLoading = true;
      const callFunction = functions.httpsCallable(
        "dutyManagement-approveReport",
      );
      return callFunction({
        organizationId: this.organizationId,
        dutyReportId: this.report.meta.id,
        reason: this.helpers.approveReportDialog.reasonValue,
        autoApproveCorrespondingTimeSheets:
          this.helpers.approveReportDialog.autoApproveCorrespondingTimeSheets,
      })
        .then(() => {
          this.helpers.approveReportDialog.isLoading = false;
          this.toggleApproveReportDialog();
          this.helpers.snackbar.message = "Dienstbericht genehmigt.";
          this.helpers.snackbar.isVisible = true;
        })
        .catch((error) => {
          this.helpers.approveReportDialog.isLoading = false;
          this.helpers.approveReportDialog.errorMessage = error.message;
          console.error("Error approving report: ", error);
        });
    },
    rejectReport() {
      this.$refs.rejectDialogForm.validate();
      if (this.helpers.rejectReportDialog.formIsValid) {
        this.helpers.rejectReportDialog.isLoading = true;
        const callFunction = functions.httpsCallable(
          "dutyManagement-rejectReport",
        );
        return callFunction({
          organizationId: this.organizationId,
          dutyReportId: this.report.meta.id,
          reason: this.helpers.rejectReportDialog.reasonValue,
        })
          .then(() => {
            this.helpers.rejectReportDialog.isLoading = false;
            this.toggleRejectReportDialog();
            this.helpers.snackbar.message = "Dienstbericht abgelehnt.";
            this.helpers.snackbar.isVisible = true;
          })
          .catch((error) => {
            this.helpers.rejectReportDialog.isLoading = false;
            this.helpers.rejectReportDialog.errorMessage = error.message;
            console.error("Error approving report: ", error);
          });
      } else {
        this.helpers.rejectReportDialog.errorMessage =
          "Fehler: Es sind nicht alle Pflichtangaben auusgefüllt.";
      }
    },
    archiveReport() {
      this.$refs.archiveDialogForm.validate();
      if (this.helpers.archiveReportDialog.formIsValid) {
        this.helpers.archiveReportDialog.isLoading = true;
        const callFunction = functions.httpsCallable(
          "dutyManagement-archiveReport",
        );
        return callFunction({
          organizationId: this.organizationId,
          dutyReportId: this.report.meta.id,
          reason: this.helpers.archiveReportDialog.reasonValue,
        })
          .then(() => {
            this.helpers.archiveReportDialog.isLoading = false;
            this.toggleArchiveReportDialog();
            this.helpers.snackbar.message = "Dienstbericht archiviert.";
            this.helpers.snackbar.isVisible = true;
          })
          .catch((error) => {
            this.helpers.archiveReportDialog.isLoading = false;
            this.helpers.archiveReportDialog.errorMessage = error.message;
            console.error("Error archiving report: ", error);
          });
      } else {
        this.helpers.archiveReportDialog.errorMessage =
          "Fehler: Es sind nicht alle Pflichtangaben auusgefüllt.";
      }
    },
    moveBackToReview() {
      this.helpers.moveBackToReviewDialog.isLoading = true;
      const callFunction = functions.httpsCallable(
        "dutyManagement-moveBackToReview",
      );
      return callFunction({
        organizationId: this.organizationId,
        dutyReportId: this.report.meta.id,
        reason: this.helpers.moveBackToReviewDialog.reasonValue,
      })
        .then(() => {
          this.helpers.moveBackToReviewDialog.isLoading = false;
          this.toggleMoveBackToReviewDialog();
          this.helpers.snackbar.message =
            "Dienstbericht erneut zur Überprüfung übergeben.";
          this.helpers.snackbar.isVisible = true;
        })
        .catch((error) => {
          this.helpers.moveBackToReviewDialog.isLoading = false;
          this.helpers.moveBackToReviewDialog.errorMessage = error.message;
          console.error("Error approving report: ", error);
        });
    },
  },
};
</script>
